// DEPENDS 
import React, {useState, useRef} from 'react';
import { Link } from 'react-router-dom';
// data 
import {guides_2} from '../../../assets/data/guides.js'

// CSS 
import "../../../CSS/TOB/Docs/Wifioption2.css"


const Wifioption2 = () => {
    // used to set which step in the guide that will be shown, default to the first one on the list.
    const idx = useRef(0)
    const [guide, setGuide] = useState(guides_2[idx.current]);
    const idx_capt = useRef(0)

    // for moving steps in teh workflow
    const handleGuide = () => {
            idx.current += 1
            // console.log(idx)
            setGuide(guides_2[idx.current])
            window.scrollTo({
                top: 120,
                behavior: "smooth"
            });
    }

    const handleBack = () => {
        if (idx.current > 0) {
            idx.current -= 1
            // console.log(idx)
            setGuide(guides_2[idx.current])
            window.scrollTo({
                top: 120,
                behavior: "smooth"
            });
        } else {
            window.alert("page error, please reload.")
            return null
        }
    }


    return(
        <div className='Wifioption2'>
            <div className='Wifioption2__return' id="button_wop2Home" style={{display: idx.current === 3 ? "flex" : "none"}}>
                <Link to="/TOBHomes" className='return__link'>Return to the Home Page</Link>
            </div>
            <div className='Wifioption2__guide' style={{display: idx.current === 3 ? "none" : "flex"}}>
                <div className='guide__viewContainer' id={`viewer_op2_${idx.current}`}>
                    
                </div>
                <div className='guide__captions'>
                    <h1 className='captions__title'>{guide.title}</h1>
                    {guide.captions.map((item) => {
                        idx_capt.current += 1
                        return(
                            <p 
                                className='captions__copy' 
                                id={`copy_op1_${idx_capt.current}`} 
                                key={`copy_op1_${idx_capt.current}`}
                            >{item}</p>
                        )
                    })}
                </div>
                <div className='guide__buttoncontainer' id="cs_bullshit">
                    <button className='buttonContainer__button' id='button_wifiback' onClick={handleBack} style={{opacity: idx.current > 0 ? "70%" : "0%"}}>Back</button>
                    <button className='buttonContainer__button' id='button_wifinext' onClick={handleGuide}>Next</button>
                </div>
            </div>
        </div>
    );
};

export default Wifioption2;